import {
  Box,
  Flex,
  forwardRef,
  Link,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Radio,
  RadioGroup,
  Stack,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { ERROR_LENGTH, ERROR_LENGTH_GREATER_THAN_MAX, ERROR_LENGTH_LESS_THAN_MIN } from "./DcaErrors";

const LengthSelector = forwardRef(
  ({ length, setLength, dcaConfigErrors, setDcaConfigErrors, tooltip, ...props }, ref) => {
    const INVEST_LENGTH_FOREVER = 0;
    const INVEST_LENGTH_FIXED = 1;

    const INVEST_LENGTH_FIXED_DEFAULT = 30;
    const INVEST_LENGTH_FIXED_MIN = 10;
    const INVEST_LENGTH_FIXED_MAX = 365;

    const [showLengthInput, setShowLengthInput] = useState(false); // default is forever

    // rolling length validation hook
    useEffect(() => {
      // TODO: BUG Maximum update depth exceeded. if changing the days too much
      setDcaConfigErrors((prevErrs) => {
        let errs = { ...prevErrs };

        if (showLengthInput) {
          // check for errors in ROLLING
          if (length < INVEST_LENGTH_FIXED_MIN) {
            errs[ERROR_LENGTH] = ERROR_LENGTH_LESS_THAN_MIN;
          } else if (length > INVEST_LENGTH_FIXED_MAX) {
            errs[ERROR_LENGTH] = ERROR_LENGTH_GREATER_THAN_MAX;
          } else {
            if (ERROR_LENGTH in errs) delete errs[ERROR_LENGTH];
          }
        } else {
          // clear the errors in FOREVER
          if (ERROR_LENGTH in errs) delete errs[ERROR_LENGTH];
        }

        return errs;
      });
    }, [showLengthInput, length, setDcaConfigErrors]);

    return (
      <Box ref={ref} {...props}>
        {/* title */}
        <Flex align="center" justify="space-between">
          <Text fontSize="lg" fontWeight="bold">
            📅 How long to invest?
          </Text>

          <Tooltip hasArrow bg="red.500" color="white" label={tooltip} fontSize="lg" placement="auto" closeDelay={500}>
            <Text fontSize="xs">ℹ️</Text>
          </Tooltip>
        </Flex>

        {/* forever/rolling selector */}
        <RadioGroup mt="0.25em" defaultValue={String(INVEST_LENGTH_FOREVER)}>
          <Stack spacing="0.25em">
            <Radio
              id="forever"
              colorScheme="blue"
              value={String(INVEST_LENGTH_FOREVER)}
              onChange={() => {
                setShowLengthInput(false);
                setLength(INVEST_LENGTH_FOREVER);
              }}
            >
              FOREVER and ever
            </Radio>

            <Radio
              id="rolling"
              colorScheme="blue"
              value={String(INVEST_LENGTH_FIXED)}
              onChange={() => {
                setShowLengthInput(true);
                setLength(INVEST_LENGTH_FIXED_DEFAULT);
              }}
            >
              ROLLING number of days
            </Radio>

            {/* show the number input for the rolling number of days */}
            {showLengthInput && (
              <>
                <Link href="/faq#rolling" fontSize="xs" isExternal display="block">
                  Check out how rolling length works.
                </Link>
                <NumberInput
                  step={1}
                  defaultValue={INVEST_LENGTH_FIXED_DEFAULT}
                  min={INVEST_LENGTH_FIXED_MIN}
                  max={INVEST_LENGTH_FIXED_MAX}
                  onChange={(lengthStr) => setLength(Number(lengthStr))}
                  clampValueOnBlur={false}
                >
                  <NumberInputField />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
                <Text fontSize="xs">
                  From {INVEST_LENGTH_FIXED_MIN} to {INVEST_LENGTH_FIXED_MAX} days.
                </Text>
              </>
            )}
          </Stack>
        </RadioGroup>
      </Box>
    );
  }
);

export default LengthSelector;
